<template>
<div :style="'background:url(' + require('@/assets/bg-top-right.png') +') fixed '" style="margin-top:200px">

     <v-row v-if="!isLoading">
          <v-col class="py-0 px-0" cols="4"></v-col>
          <v-col class="py-0 px-0" cols="4">
               <div class="text-center mb-12">
                    <span :style="'font-weight: bold;font-size:18px; color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ getName('P5S1HeadTitle') }}</span>
                    <h1 class="textSizeT">{{ getName('P5S1Title') }}</h1>
                    <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D') "></div>
               </div>
          </v-col>
          <v-col cols="3"></v-col>
          <v-col id=" hidden-sm-and-down" cols="1"> 
                              <v-row @click="resultRoute"  class=" hand goToResult">
                                   <v-col  class="py-0 " cols="12" lg="7" md="7">
                                        <div  style="background:#fff; border-radius:50%;padding:15px" class="shadow-drop-center" size="140" >
                                             <v-img   style=" border-radius:30%"  width="250"  :src="require('@/assets/signature.gif')"></v-img> 
                                        </div>
                                   </v-col>
                                   <!-- <v-col class="py-5 hidden-s8-and-down" cols="3" lg="4" md="4">
                                        <h1 style="color: #888">{{$t('result')}}</h1>
                                        <h3 style="color: #aaa">{{$t('clickHere')}}</h3>
                                   </v-col> -->
                              </v-row> 
                    </v-col>
     </v-row>
     <v-row v-else>
          <v-col cols="4"></v-col>
          <v-col cols="4">
               <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
               <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader><br><br>
          </v-col>
          <v-col cols="4"></v-col>
     </v-row>

     <section>
          <v-row>
               <v-col v-if="!isLoading" cols="12" lg="8" md="8" sm="12">
                    <p class="textSizeST" :style="'color:' +(settings[0] ? settings[0].color : '#2F839D') ">{{ getName('P5S1SouTitle1') }}</p>
                    <p class="textSizeP">{{ getName('P5S1Prag1') }}</p>
               </v-col>
               <v-col v-else>
                    <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                    <v-skeleton-loader ref="skeleton" type="paragraph"></v-skeleton-loader>
               </v-col>
               <v-col cols="12" lg="1" md="1" sm=""></v-col>
               <v-col v-if="!isLoading" cols="12" lg="3" md="3" sm="12">
                    <v-img max-width="100%" :src="'espace_patient/'+ (checkDefault('P5S1Img1') ? checkDefault('P5S1Img1').img : '') | URL"></v-img>
               </v-col>
               <v-col v-else cols="12" lg="3" md="3" sm="12">
                    <v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader>
               </v-col>
          </v-row>
     </section>

     <section style="margin-top: 120px">
          <v-row>
               <v-col v-if="!isLoading" cols="12" lg="3" md="3" sm="12">
                    <v-img max-width="100%" :src="'espace_patient/'+( checkDefault('P5S2Img1')  ? checkDefault('P5S2Img1').img : '') | URL"></v-img>
               </v-col>
               <v-col v-else>
                    <v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader>
               </v-col>
               <v-col cols="12" lg="1" md="1" sm=""></v-col>
               <v-col v-if="!isLoading" cols="12" lg="8" md="8" sm="12">
                    <p class="textSizeST" :style="'color:' +(settings[0] ? settings[0].color : '#2F839D') ">{{ getName('P5S2SouTitle1') }}</p>
                    <p class="textSizeP">{{ getName('P5S2Prag1') }}</p>
               </v-col>
               <v-col v-else>
                    <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                    <v-skeleton-loader ref="skeleton" type="paragraph"></v-skeleton-loader>
               </v-col>
          </v-row>
     </section>

     <section style="margin-top: 120px">
          <v-row>
               <v-col v-if="!isLoading" cols="12" lg="8" md="8" sm="12">
                    <p class="textSizeST" :style="'color:' +(settings[0] ? settings[0].color : '#2F839D') ">{{ getName('P5S3SouTitle1') }}</p>
                    <p class="textSizeP">{{ getName('P5S3Prag1') }}</p>
               </v-col>
               <v-col v-else>
                    <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                    <v-skeleton-loader ref="skeleton" type="paragraph"></v-skeleton-loader>
               </v-col>
               <v-col cols="12" lg="1" md="1" sm=""></v-col>
               <v-col v-if="!isLoading" cols="12" lg="3" md="3" sm="12">
                    <v-img max-width="100%" :src="'espace_patient/'+ ( checkDefault('P5S3Img1')  ? checkDefault('P5S3Img1').img : '') | URL"></v-img>
               </v-col>
               <v-col v-else>
                    <v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader>
               </v-col>
          </v-row>
     </section>

     <section style="margin-top: 120px">
          <v-row>
               <v-col v-if="!isLoading" cols="12" lg="3" md="3" sm="12">
                    <v-img max-width="100%" :src="'espace_patient/'+ ( checkDefault('P5S4Img1')  ? checkDefault('P5S4Img1').img : '') | URL"></v-img>
               </v-col>
               <v-col v-else>
                    <v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader>
               </v-col>
               <v-col cols="12" lg="1" md="1" sm=""></v-col>
               <v-col v-if="!isLoading" cols="12" lg="8" md="8" sm="12">
                    <p class="textSizeST" :style="'color:' +(settings[0] ? settings[0].color : '#2F839D') ">{{ getName('P5S4SouTitle1') }}</p>
                    <p class="textSizeP">{{ getName('P5S4Prag1') }}</p>
               </v-col>
               <v-col v-else>
                    <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                    <v-skeleton-loader ref="skeleton" type="paragraph"></v-skeleton-loader>
               </v-col>
          </v-row>
     </section>
</div>
</template>

<script>
export default {

     methods: {
          resultRoute() {
               this.$router.push('resultats')
          },
          /********************************** */

          isShow(item) {
               let array = this.$store.state.status.filter(e => e.idPage == 5)
               if (array) {
                    for (let i = 0; i < array.length; i++) {
                         if (array[i].idSection == item) {
                              return false
                         } else {
                              return true
                         }
                    }
               }
               return true
          },
          /********************************** */
     },
     computed: {

     }
}
</script>

<style>

</style>
